import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Check, Plus } from "lucide-react";
import { calculateAcres } from "../utils/mapCalculations";

const AddAreaDialog = ({
  open,
  onOpenChange,
  pendingPolygon,
  onConfirm,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading text-xl uppercase tracking-tight text-[#00341d]">
            Area Added Successfully
          </AlertDialogTitle>
          <AlertDialogDescription>
            {pendingPolygon && (
              <span className="block text-lg font-semibold text-[#00341d] my-2">
                {calculateAcres(pendingPolygon).toFixed(2)} acres
              </span>
            )}
            Would you like to add another area to clear, or are you finished selecting areas?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => onConfirm(false)} className="bg-[#00341d] text-white hover:bg-[#002816]" data-testid="confirm-add-area">
            <Check className="w-4 h-4 mr-2" />
            Finished
          </AlertDialogCancel>
          <AlertDialogAction onClick={() => onConfirm(true)} className="bg-[#d97706] hover:bg-[#b45309]" data-testid="add-another-area">
            <Plus className="w-4 h-4 mr-2" />
            Add Another Area
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AddAreaDialog;
